import Vue from 'vue'
import Vuex from 'vuex'
import { clientGetUserInfo, clientGetTryNo, clientLogin, clientVipDialog } from '@/client'
import { apiOfficeLogin } from '@/api'
Vue.use(Vuex)

/**
 * @description 组件内不许使用 state, state 作为私有的状态
 * @description 其他地方需要获取数据全部使用 getters 导出，
 * @description 不许使用 cookie 或者 localStory sessionStory 存储信息（浏览器可以清空数据。如果清空数据，网页已经退出登录。而客户端的状态时正常登录）
 */
const store = new Vuex.Store({
  state: {
    /**
     * 浏览器用户结构
     * address: ""
     avatar: "https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTJU5SDEJBEDRptnUicOiaOmKCwmfLT4Awlx65ShOia3npD00SP2KiaKgTHPoX9GOuYrQLflWp5L4ibxDTw/132"
     bind_info: {has_mobile: false, has_qq: false, has_server_id: false, has_wx: true, mobile: "", …}
     birthday: ""
     current_time: "1614738419"
     education: 0
     email: ""
     gender: 0
     is_continuous: "", // 是否为续费用户
     is_first_order: false, // 是否为第一次充值
     is_tourist: false
     ks_sid: "0385b4c7-2df7-4e13-a889-8c4ce9233101"
     latest_order_id: ""
     latest_order_type: ""
     login_frm: 0
     mobile: ""
     nickname: "邓伟驰"
     profession: 0
     register_frm: 0
     register_sec: "1612143524"
     sign: ""
     token: "lIeFcx-BjRdtJEUgO-SsoinmKcw9vAEEYGJRoydfA6C3i1BVpm5Asxkm62CwMi5LfijvpYSE_x7PAlsCSHg9Lg"
     uid: "lb1124690022740760"
     vip_ex_date: "1616404494"
     vip_sub_type: ""，
     vip_type: "5"， // vip类型 如果为0 不是vip
     web_token: "lIeFcx-BjRdtJEUgO-SsoinmKcw9vAEEYGJRoydfA6C3i1BVpm5Asxkm62CwMi5LfijvpYSE_x7PAlsCSHg9Lg"
     */
    userInfo: null,
    // vip页面的url
    vipPageUrl: `https://brvip.liebao.cn/${clientGetTryNo()}/v2?from=15`,
    // office 登录信息
    officeToken: '',
    officeUid: '',
  },
  mutations: {
    // 通过客户端获取用户信息
    getUserInfo (state) {
      const data = clientGetUserInfo()
      if (data) {
        state.userInfo = data.data.user_info
        return state.userInfo
      }
      return null
    },
    // 打开VIP 页面
    openVipWindow (state) {
      window.open(state.vipPageUrl, '_blank')
    },
    openLoginWindow (state) {
      clientLogin()
    },
    openVipDialog (state) {
      clientVipDialog()
    }
  },
  getters: {
    // 是否为vip 类型
    isVip (state) {
      return state.userInfo &&
        state.userInfo.vip_type &&
        state.userInfo.vip_type !== '0'
    },
    // 用户头像
    avatar (state) {
      return state.userInfo ? state.userInfo.avatar : ''
    },
    // 是否登录
    isLogin (state) {
      return state.userInfo
    },
    // 登录使用
    token (state) {
      return state.officeToken
    },
    uid (state) {
      return state.officeUid
    }
  },
  actions: {
    officeLogin ({ state }) {
      return new Promise((resolve, reject) => {
        apiOfficeLogin({
          uid: state.userInfo.uid,
          token: state.userInfo.token,
          login_type: Number.parseInt(process.env.VUE_APP_LOGIN_TYP),
        }).then((response) => {
          const { token, uid } = response
          state.officeToken = token
          state.officeUid = uid
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    }
  }
})

export default store
